import { render, staticRenderFns } from "./SearchTransfer.vue?vue&type=template&id=d4a6cd04"
import script from "./SearchTransfer.vue?vue&type=script&lang=js"
export * from "./SearchTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports